module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-white@3x-0a73ed6e.svg";